export default __webpack_public_path__ + "static/media/landing-image-farmlands.9d6150a5.jpg";